<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{this.data.id ? 'Edit' : 'New'}} Key</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Key Tag ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Key Tag</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="keyTag" [ngModel]="data.keyTag" required>
                        </div>
                    </div>

                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm" [hidden]="keyLogService.buildingsForUpdate.length < 2">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <select class="form-control"
                                    name="buildingId"
                                    [ngModel]="data.buildingId"
                                    required
                                    (change)="changeBuilding($event.target.value)"
                                    #buildingSelect
                                    [disabled]="buildingSelectIsDisabled">
                                <option value="" hidden></option>
                                <option *ngFor="let build of keyLogService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Unit ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Unit/Room</label>
                        </div>
                        <div class="col-md-8">
                            <search-select [ngModel]="data.suiteId"
                                           name="suiteId"
                                           #suiteSelect
                                           (ngModelChange)="changeUnit($event)"
                                           [data]="suiteToSearchSelect(suites)">
                            </search-select>
                            <input *ngIf="suiteSelect.value == '0'" class="form-control"
                                   [ngModel]="data.suiteNumber" name="otherSuite"
                                   placeholder="Other Unit Number" maxlength="255">
                            <spinner [spinnerShow]="buildingSelect.value &&
                                                    buildingSelect.value != 'null' &&
                                                    !suites.length || isShowSpinnerWhenOneBuilding()">
                            </spinner>
                        </div>
                    </div>

                    <!-- ___ Purpose ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Purpose</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="purpose" [ngModel]="data.purpose">
                        </div>
                    </div>

                    <!-- ___ Status ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Status</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <select [ngModel]="data.status" name="status" id="status" class="form-control">
                                <option value="available" selected>Available</option>
                                <option value="signet_out">Signed Out</option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Notes  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Notes</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <textarea class="form-control" name="notes" [ngModel]="data.notes" maxlength="255"></textarea>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-modal/key-log-modal.component.html